import React, { memo } from 'react';
import propTypes from 'prop-types';
;
import { Button, Columns, Column } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import posed from 'react-pose';

const Notification = posed.div({
  visible: {
    y: 0,
  },
  invisible: {
    y: '200%',
  },
});

function SaveChangesToast({
  message,
  buttonType,
  onClickButton,
  isLoading,
  isDisabled,
  isVisible,
}) {
  return (
    <Notification
      pose={isVisible ? 'visible' : 'invisible'}
      className="notification ui-toast is-gradient-bright"
    >
      <Columns isGapless isVCentered>
        <Column className="notification-content">
          <span className="icon is-medium">
            <FontAwesomeIcon icon={['fal', 'exclamation-circle']} size="lg" />
          </span>
          {message}
        </Column>
        <Column isSize="narrow">
          <Button
            isColor="white"
            className="is-long"
            type={buttonType}
            onClick={onClickButton}
            isLoading={isLoading}
            disabled={isDisabled}
          >
            <span>Save</span>
          </Button>
        </Column>
      </Columns>
    </Notification>
  );
}

SaveChangesToast.defaultProps = {
  buttonType: 'button',
  onClickButton: () => {},
  isLoading: false,
  isDisabled: false,
};

SaveChangesToast.propTypes = {
  message: propTypes.string.isRequired,
  buttonType: propTypes.string,
  onClickButton: propTypes.func,
  isLoading: propTypes.bool,
  isDisabled: propTypes.bool,
  isVisible: propTypes.bool.isRequired,
};

const memoizedSaveChangesToast = memo(SaveChangesToast);

export { memoizedSaveChangesToast as SaveChangesToast };
